import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import Swal from "sweetalert2";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import Download from "../../../components/Downloads";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import SearchField from "../../../components/SearchField";
import BookingStatus from "../../../components/UI/BookingStatus";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import Location from "../../../components/UI/Location";
import Vessel from "../../../components/UI/VesselFilter";
import { getAncillary } from "../../../utils/ApiCalls/Ancillary";
import { createDownloads } from "../../../utils/ApiCalls/Downloads";
import { getBookings } from "../../../utils/ApiCalls/Leads";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage/index";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import MemberType from "../../../components/UI/MemberFilter";
import DRSFilter from "../../../components/UI/DRSFilter";
import { useDebounce } from "../../../hooks";
import { marketConsentColumn } from "../../../utils/CommonFunctions/utils";

const parseCreatedAtRange = (createdAt) => {
  if (!createdAt) return null;
  try {
    const [start, end] = JSON.parse(createdAt);
    if (start && end) return [dayjs(start, "YYYY-MM-DD"), dayjs(end, "YYYY-MM-DD")];
  } catch (e) {
    // unparsable — treat as no selection
  }
  return null;
};

const Booking = () => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Cabin Bookings List",
      route: "/website/bookings/leads",
    },
  ];
  const [active, setActive] = useState("listing");
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [columns, setColumns] = useState([]);
  const [pending_count, setPendingCount] = useState(0);
  const [ancillary, setAncillary] = useState();
  const [success_count, setSuccessCount] = useState(0);
  const [sailing_date, setSaling_date] = useState(
    () => new URLSearchParams(window.location.search).get("sailing_date") || undefined
  );
  const [drs_status, setDRSStatus] = useState(
    () => new URLSearchParams(window.location.search).get("drs_status") || ""
  );
  const [created_at, setCreatedAt] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.has("created_at")
      ? params.get("created_at")
      : JSON.stringify([
          moment().subtract(3, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ]);
  });
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [locationData, setLocationData] = useState([]);
  const [locationId, setLocationId] = useState(
    () => new URLSearchParams(window.location.search).get("locationId") || ""
  );
  const [status, setStatus] = useState(
    () => new URLSearchParams(window.location.search).get("status") || ""
  );
  const [disableSpecificDate, setDisableSpecificDate] = useState([]);
  const [vessel, setVessel] = useState([]);
  const [vesselId, setVesselId] = useState(
    () => new URLSearchParams(window.location.search).get("vesselId") || ""
  );
  const [type, setType] = useState("");
  
  
    const locationP = useLocation();
  
    const [page, setPage] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
    );
    const [pageSize, setPageSize] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
    );
    const [search, setSearch] = useState(
      () => new URLSearchParams(locationP.search).get("search") || ""
    );
    const debouncedSearch = useDebounce(search, 1000);
    const [sort, setSort] = useState();
    const [order, setOrder] = useState();

    useEffect(() => {
      const params = new URLSearchParams(locationP.search);
      const pageParam = parseInt(params.get("page")) || 1;
      const pageSizeParam = parseInt(params.get("pageSize")) || 10;
      const searchParam = params.get("search") || "";
  
      // setPage(pageParam);
      // setPageSize(pageSizeParam);
      setSearch(searchParam);
    }, [locationP.search]);
  
    useEffect(() => {
      const params = new URLSearchParams();
      const currentParams = new URLSearchParams(locationP.search);
  
      params.set("page", page);
      params.set("pageSize", pageSize);
      if (search) params.set("search", search);
      params.set("created_at", created_at);
      if (sailing_date) params.set("sailing_date", sailing_date);
      if (drs_status) params.set("drs_status", drs_status);
      if (locationId) params.set("locationId", locationId);
      if (status) params.set("status", status);
      if (vesselId) params.set("vesselId", vesselId);

      if (currentParams.toString() !== params.toString()) {
        navigate({ search: params.toString() }, { replace: true });
      }
    }, [
      page,
      pageSize,
      debouncedSearch,
      created_at,
      sailing_date,
      drs_status,
      locationId,
      status,
      vesselId,
      navigate,
      locationP.search,
    ]);
  


  const sortHandler = (options) => {
    if (Object.keys(options).length > 0) {
      setSort(options.columnKey);
      setOrder(
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined
      );
      setPage(1);
    }
  };
  const dateRender = (current) => {
    const isDisabled =
      !disableSpecificDate.filter(
        (item) => item.format("YYYY-MM-DD") === current.format("YYYY-MM-DD")
      ).length > 0;
    return (
      <div
        className="ant-picker-cell-inner"
        style={{
          color: isDisabled ? "inherit" : "white",
          background: isDisabled ? "inherit" : "blue",
          borderRadius: "100px",
        }}
      >
        {current.date()}
      </div>
    );
  };

  const setPositionalValue = (data) => {};
  useEffect(() => {
    getancillaryData();
  }, []);
  const getancillaryData = async () => {
    let data = await getAncillary({ page: 1, limit: 10 });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setAncillary(data.data);
    }
  };
  useEffect(() => {
    if (ancillary?.length)
      setColumns([
        {
          title: "Sl",
          width: 30,
          dataIndex: "id",
          key: "id",
          fixed: "left",
          render: (position, record, index) =>
            (page - 1) * pageSize + index + 1,
        },
        {
          title: "Member Id",
          dataIndex: "member_id",
          key: "member_id",
          width: 50,
          render: (item) => (item ? item : "-"),
        },
        {
          title: "Package Id",
          dataIndex: "package_id",
          key: "package_id",
          sorter: (a, b) => "",
          width: 50,
        },
        {
          title: "Embarkation Port",
          dataIndex: "port",
          key: "port",
          width: 10,
        },
        {
          title: "Booking No",
          dataIndex: "booking_no",
          key: "booking_no",
          width: 10,
          sorter: (a, b) => "",
        },
        {
          title: "Cabin no",
          dataIndex: "cabin_no",
          key: "cabin_no",
          sorter: (a, b) => "",
          width: 10,
          render: (item, booking) => <div>{booking?.cabin_no ?? "--"}</div>,
        },
        {
          title: "Booking Date",
          dataIndex: "created_at",
          key: "created_at",
          sorter: (a, b) => "",
          width: 150,
          render: (item, record) => (
            <div>{moment(item).utc().format("DD-MM-YYYY HH:mm")}</div>
          ),
        },
        {
          title: "Sailing Date",
          dataIndex: "sailing_date",
          key: "sailing_date",
          sorter: (a, b) => "",
          width: 150,
          render: (item, record) => (
            <div>{moment(item).format("DD-MM-YYYY")}</div>
          ),
        },
        {
          title: "Cabin Category",
          dataIndex: "category",
          key: "category",
          sorter: (a, b) => "",
          render: (item, record) => <div>{item || record?.cabin_category}</div>,
          width: 10,
        },
        {
          title: "Passengers",
          dataIndex: "first_name",
          key: "first_name",

          width: 30,
          render: (item, record) => (
            <div>
              {record.first_name
                ? record.first_name + " " + record.last_name
                : "-"}
            </div>
          ),
        },
        {
          title: "Amount",
          dataIndex: "price",
          key: "price",
          sorter: (a, b) => "",
          width: 10,
        },
        {
          title: "Cabin Charges",
          dataIndex: "cabin_charges",
          key: "cabin_charges",
          width: 120,
          render: (item) => item ?? "-",
        },
        {
          title: "Port Charges",
          dataIndex: "port_charges",
          key: "port_charges",
          width: 120,
          render: (item) => item ?? "-",
        },
        {
          title: "Ancillary Charges",
          dataIndex: "ancillary_charges",
          key: "ancillary_charges",
          width: 120,
          render: (item) => item ?? "-",
        },
        {
          title: "Referral Promo Discount",
          dataIndex: "referral_promo_discount",
          key: "referral_promo_discount",
          width: 150,
          render: (item) => item ?? "-",
        },
        {
          title: "Currency",
          dataIndex: "currency",
          key: "currency",
          sorter: (a, b) => "",
          width: 10,
        },
        {
          title: "Rate Plan",
          dataIndex: "fare_code_name",
          key: "fare_code_name",
          sorter: (a, b) => "",
          width: 200,
        },

        {
          title: "Booking Status",
          dataIndex: "status",
          key: "status",
          width: 10,
          render: (item, record) => (
            <div>
              {record.booking_no?.includes("TE") ? "Pending" : "Confirmed"}
            </div>
          ),
        },
        marketConsentColumn,
        {
          title: "Location",
          dataIndex: "location",
          key: "location",

          width: 10,
        },
        {
          title: "Vessel",
          dataIndex: "vessel_name",
          key: "vessel_name",

          width: 150,
        },
        {
          title: "No Of Pax",
          dataIndex: "no_of_pax",
          key: "no_of_pax",

          width: 100,
          render: (item, record) => (
            <div>
              {Number(record.adult) +
                Number(record.child) +
                Number(record.infant)}
            </div>
          ),
        },
        ...(Array.isArray(ancillary) ? ancillary : []).map((item) => ({
          title: item.english_title,
          dataIndex: item.ancillary_code,
          key: item.ancillary_code,
          width: 10,
        })),
        {
          title: "DRS Status",
          key: "drs_status",
          width: 100,
          render: (text, record) => <div>{text || "-"}</div>,
        },
        {
          title: "Action",
          key: "operation",
          width: 100,
          render: (text, record) => (
            <div className="table_action_btn">
             {!record?.member_id&& <button
                className="btn delete_btn"
                onClick={() => handleEdit(record.booking_no, record.cabin_no)}
                title="View"
              >
                <i className="ri-eye-line"></i>
              </button>}
            </div>
          ),
        },
      ]);
  }, [page, pageSize, search, drs_status, sailing_date, created_at, ancillary]);

  useEffect(() => {
    if (active === "listing" && ancillary) {
      getVesselData();
      getData(page, sort, order);
    }
  }, [page, pageSize, debouncedSearch, sailing_date, created_at, status, ancillary, sort, order]);

  const getVesselData = async () => {
    let vessels = await getVessels();
    if (vessels.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: vessels.error, type: "error" },
      });
    } else {
      vessels.push({ id: null, name: "All" });
      setVessel(vessels);
    }
  };

  const getData = async (value, sortBy = sort, orderBy = order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = {
      search: search,
      page: value,
      limit: pageSize,
      sailing_date,
      drs_status,
      type,
      ancillary: ancillary.map((item) => item.ancillary_code),
      created_at,
    };
    if (status) {
      args = { ...args, status: status };
    }
    if (locationId) {
      args = {
        ...args,
        location_id: locationId === -1 ? undefined : locationId,
      };
    }
    if (orderBy) {
      if (sortBy) {
        args = { ...args, sort: sortBy };
      }
      args = { ...args, order: orderBy };
    }
    if (vesselId && vessel.length) {
      let selectedVessel = vessel.find(function (element) {
        return element.id == vesselId;
      });
      if (selectedVessel) {
        args = { ...args, vessel_name: selectedVessel.name };
      }
    }

    let data = await getBookings(args);
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      setPendingCount(data.pending_count);
      setSuccessCount(data.success_count);
      setPositionalValue(data.data);
      if (data.sailingDates) {
        const sailingDates = data.sailingDates.map((e) =>
          moment(e.sailing_date)
        );
        setDisableSpecificDate(sailingDates);
      }
      if (locationData.length === 0) {
        data.locations.push({ location_id: -1, location: "ALL" });
        setLocationData(data.locations);
      }
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleEdit = async (id, cabin_no) => {
    navigate("/website/bookings/cabin-booking/edit/" + id + "?cabin_no=" + cabin_no);
  };
  const saveDownloads = async () => {
    if (!checkPermission(permission, "download_per", "Cabin Bookings",window?.location?.pathname)) {
      return message.error("Download permission missing");
    }

    if (count === 0) {
      return message.error("There are no bookings to download");
    }

    let args = {
      search,
      sailing_date,
      created_at,
      ...(status && { status }),
      ...(locationId && {
        location_id: locationId === -1 ? undefined : locationId,
      }),
    };

    if (vesselId) {
      const selectedVessel = vessel.find(({ id }) => id === vesselId);
      if (selectedVessel) {
        args.vessel_name = selectedVessel.name;
      }
    }
    if (JSON.parse(args.created_at).filter((item) => item !== "").length < 2) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Need date range",
      });
      return;
    }
    const request = {
      module_name: "cabin_booking",
      created_by: userDetails?.id,
      search_params: args,
    };

    try {
      const data = await createDownloads(request);
      if (data.error) {
        throw new Error("An error occurs when you try to download");
      }
      addlog("Bookings Downloaded", "Bookings", args, userDetails.id);
      message.success("Download request submitted");
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Cabin Bookings"}>
      <CustomHeaderTitle title={"Cabin Booking"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Cabin Booking"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Cabin Bookings List", value: "listing" },
                { value: "downloads", title: "Downloads" },
                { value: "logs", title: "History Logs" },
              ]}
              activeTab={active}
              setActiveTab={(item) => {
                setCreatedAt(
                  JSON.stringify([
                    moment().subtract(3, "months").format("YYYY-MM-DD"),
                    moment().format("YYYY-MM-DD"),
                  ])
                );
                setActive(item);
              }}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item" style={{ flexWrap: "wrap", rowGap: "10px" }}>
                  {/* <h5 className="card-title">Cabin Bookings List</h5> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    <BookingStatus
                      width={"160px"}
                      getData={getData}
                      setPage={setPage}
                      setStatus={setStatus}
                      status={status}
                    />
                    <Location
                      width={"150px"}
                      getData={getData}
                      setPage={setPage}
                      locationData={locationData}
                      setLocationId={setLocationId}
                      locationId={locationId}
                    />
                    <Vessel
                      setVesselId={setVesselId}
                      vesselData={vessel}
                      vesselId={vesselId}
                      getData={getData}
                      setPage={setPage}
                      width={150}
                    />

                    <DatePicker
                      style={{
                        width: "150px",
                      }}
                      placeholder="Sailing Date"
                      label="Sailing Date"
                      value={sailing_date ? dayjs(sailing_date) : null}
                      onChange={(date, dateString) => {
                        setSaling_date(dateString || undefined);
                        setPage(1);
                      }}
                      dateRender={dateRender}
                      disabledDate={(current) => {
                        return !disableSpecificDate.some((date) =>
                          current.isSame(date, "day")
                        );
                      }}
                    />
                    <DRSFilter
                      setDrsStatus={setDRSStatus}
                      drsStatus={drs_status}
                      getData={getData}
                      setPage={setPage}
                      width={150}
                    />
                    <RangePicker
                      style={{
                        width: "250px",
                      }}
                      onChange={(date, dateString) => {
                        setCreatedAt(
                          dateString[0] && dateString[1] ? JSON.stringify(dateString) : ""
                        );
                        setPage(1);
                      }}
                      value={parseCreatedAtRange(created_at)}
                      format={"YYYY-MM-DD"}
                      disabledDate={(current) => {
                        return moment() <= current;
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setSearch("");
                        setStatus("");
                        setVesselId("");
                        setLocationId("");
                        setSaling_date(undefined);
                        setDRSStatus("");
                        setCreatedAt(
                          JSON.stringify([
                            moment().subtract(3, "months").format("YYYY-MM-DD"),
                            moment().format("YYYY-MM-DD"),
                          ])
                        );
                        setPage(1);
                      }}
                      style={{
                        marginRight: "10px",
                        background: "var(--red)",
                        fontWeight: "500",
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => saveDownloads()}
                      style={{
                        marginRight: "10px",
                        background: "#0ab402",
                        fontWeight: "500",
                      }}
                    >
                      Download
                    </Button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <RadioGroup
                        row
                        value={status}
                        onChange={(e) => {
                          setStatus(e.target.value);
                          setPage(1);
                        }}
                        style={{
                          marginRight: "auto",
                          marginBottom: "10px",
                          alignItems: "center",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {[
                          { label: "Confirmed Bookings", value: "pending", count: success_count, color: "#0ab402" },
                          { label: "Pending Bookings", value: "success", count: pending_count, color: "#eb6363" },
                        ].map((item) => (
                          <FormControlLabel
                            key={item.value}
                            value={item.value}
                            label={`${item.label}: ${item.count}`}
                            style={{
                              marginLeft:"0px",
                              marginRight: "6px",
                              fontWeight: 500,
                              color: "#ffffff",
                              background: item.color,
                              borderRadius: "4px",
                              padding: "2px 10px 2px 2px",
                            }}
                            control={
                              <Radio
                                sx={{
                                  color: "#ffffff",
                                  "&.Mui-checked": {
                                    color: "#ffffff",
                                  },
                                }}
                              />
                            }
                          />
                        ))}
                      </RadioGroup>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(1);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      sortHandler={sortHandler}
                      title={"Cabin Bookings"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "downloads" && (
          <Download
            type={"Bookings"}
            slug={"/website/bookings/cabin-booking/edit/"}
            refreshlog={active}
            module={"cabin_booking"}
          />
        )}
        {active === "logs" && (
          <Logs
            type={"Bookings"}
            slug={"/website/bookings/cabin-booking/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default Booking;
